import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => {
  return createStyles({
    resourceGrid: {
      paddingBottom: '2%',
    },
  });
});
